module.exports = __webpack_public_path__ + "static/img/17d.0bebaab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/17d.jpg
// module id = jDMm
// module chunks = 0